import { useState } from "react";
import { InfoIcon } from "../../assets/icons/icons";
import { useConfig } from "../../contexts/ConfigContext";
import PieChart from "../Charts/PieChart";
import PillarInfoModal from "./PillarInfoModal"
import "./pillar.css";

const ReportPillarScore = ({ pillarData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { config } = useConfig();

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const totalRespondents =
    pillarData.grade_breakdown.reduce((sum, curr) => sum + curr.number_of_respondents, 0);

  return (
    <>
      <div className="pillar-score-container">
        <div className="pillar-title-container">
          <h3 className="pillar-title">{pillarData.pillar_name}
            <InfoIcon className='info-icon' onClick={toggleModal} />
          </h3>
          <PillarInfoModal
            pillarData={pillarData}
            isOpen={isModalOpen}
            closeModal={toggleModal}
          />
          {/* Map the participant percentages */}
          <div className="pillar-grade-container">
            {pillarData.grade_breakdown.map((item) => {
              const pct = item.number_of_respondents / totalRespondents * 100;
              const color = config.gradeScale[item.grade].color;
              return (
                <p key={pillarData.pillar_id + item.grade} className="pillar-grade-text" style={{ color }}>
                  <strong>{item.grade}</strong>{' '}
                  <span className="pillar-grade-subtext">
                    {item.number_of_respondents} participants
                  </span>
                  {' '}({pct.toFixed(0)}%{""})
                </p>
              );
            })}
          </div>
        </div>
        <div>
          <PieChart 
            gradeBreakdown={pillarData.grade_breakdown}
            avgScore={pillarData.avg_score}
            avgGrade={pillarData.avg_grade}
            gradeScale={config.gradeScale}
          />
        </div>
      </div>
    </>
  );
}

export default ReportPillarScore;
